import React from 'react';
import { motion } from 'framer-motion';
import { trackEvent } from '../lib/metaPixel';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  /**
   * When true, the button redirects to the Shopify checkout and fires the
   * Meta Pixel AddToCart event. When false (default), it scrolls to the
   * #oferta section on the page.
   */
  checkout?: boolean;
}
export function CTAButton({
  children,
  className = '',
  checkout = false
}: CTAButtonProps) {
  const handleCheckoutClick = () => {
    trackEvent('AddToCart', {
      content_name: 'Protocolo Vientre Plano 40+',
      content_ids: ['55668519665737'],
      content_type: 'product',
      value: 6.39,
      currency: 'USD'
    });
  };
  const sharedClass = `inline-block bg-coral hover:bg-coral-hover text-white font-semibold py-4 px-8 rounded-full shadow-lg hover:shadow-xl transition-colors duration-300 text-center text-lg md:text-xl ${className}`;
  if (checkout) {
    return <motion.a href="https://metodoeva.com/cart/55668519665737:1" target="_blank" rel="noopener noreferrer" onClick={handleCheckoutClick} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={sharedClass} data-id="element-14">
        {children}
      </motion.a>;
  }
  return <motion.a href="#oferta" whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={sharedClass} data-id="element-15">
      {children}
    </motion.a>;
}